
/**
 * Utility functions to detect device types and environments
 */

/**
 * Checks if the current device is running iOS
 */
export function isIOSDevice(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
}

/**
 * Checks if the app is running in a native mobile environment
 * This is a basic check that can be refined based on your specific WebView implementation
 */
export function isRunningInNativeApp(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isStandalone = 'standalone' in window.navigator && (window.navigator as any).standalone;
  const isInWebAppiOS = userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');
  const isWebView = userAgent.includes('wkwebview') || userAgent.includes('mobile') && !userAgent.includes('safari');
  
  return isStandalone || (isInWebAppiOS && isWebView);
}
